import MyUHLManifestContainer from "../containers/MyUHLManifestContainer";

const MyUHLManifestPage = () => {
    return <MyUHLManifestContainer />;
};

export default MyUHLManifestPage;
